module.exports = __webpack_public_path__ + "c3efbdf68d9b13d68f86652cd72962fe.png";